export const tableHeader = [
  { id: 'name', cellName: 'Name', isSort: true, defaultSortValue: 'asc' },
  { id: 'corporates', cellName: 'Corporates' },
  { id: 'email', cellName: 'Email' },
  // { id: 4, cellName: 'Admin' },
  { id: 'actions', cellName: 'Actions' },
];
